import { createDomain } from 'effector';

const domain = createDomain('charts');

const chartsModel = {
    events: {
        eventCaught: domain.event<any>(),
        navigateEventCaught: domain.event<{ qInstanceId: number; path: string }>(),
    },
};

export default chartsModel;
